import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./UniversityAllCourses.css";

const UniversityAllCourses = () => {
  let navigator = useNavigate();

  const [universities, setUniversities] = useState([]);
  const [universityId, setUniversityId] = useState("");
  const [courseName, setCourseName] = useState([]);

  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  useEffect(() => {
    // Fetch universities list from API
    axios
      .get(`${API_BASE_URL}/universities`)
      .then((response) => {
        const universitiesData = response.data?.data || [];
        setUniversities(universitiesData);
      })
      .catch((error) => console.log(error));
  }, [API_BASE_URL]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/all-courses/${universityId}`)
      .then((response) => {
        console.log(response);

        const courseData = response.data?.data || [];
        setCourseName(courseData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [universityId]);

  const handleAddCourseNav = () => {
    navigator("/college-add-course");
  };

  const handleAllCourseNav = () => {
    navigator("/college-all-courses");
  };

  const handleEdit = (id) => {
    navigator(`/university-edit-course/${id}`);
  };
  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this course?")) {
      axios
        .delete(`${API_BASE_URL}/courses/${id}`)
        .then(() => {
          // Update the courses list by filtering out the deleted course
          setCourseName((prevCourses) =>
            prevCourses.filter((course) => course._id !== id)
          );
        })
        .catch((error) => console.log(error));
    }
  };
  return (
    <>
      <div id="classes-inner-wrapper">
        <div className="classes-header-div">
          <h5>Course</h5>

          <div className="college-all-course-nav-btns-table">
            <Link to={"/college-add-course"}>
              <button
                className="college-add-course-add-btn-table-page"
                onClick={handleAddCourseNav}
              >
                + Add New Course
              </button>
            </Link>
            <Link to={"/college-all-courses"}>
              <button
                className="college-all-course-btn-table-page"
                onClick={handleAllCourseNav}
              >
                All Courses
              </button>
            </Link>
          </div>
        </div>

        <div className="ms-4 d-flex gap-2">
          <label className="new-chapter-label">University Name</label>
          <select
            className="new-chapter-dropdown"
            value={universityId}
            onChange={(e) => setUniversityId(e.target.value)}
            required
          >
            <option value="">-Select University-</option>
            {universities.map((university) => (
              <option key={university._id} value={university._id}>
                {university.universityName}
              </option>
            ))}
          </select>
        </div>

        {/* table */}
        <div className="classes-table-container">
          <h5>All Courses</h5>
          <table className="classes-table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Courses</th>
                <th>Semesters</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {courseName.map((course, idx) => (
                <tr key={course._id}>
                  <td>{idx + 1}</td>
                  <td>{course.courseName}</td>
                  <td>
                    {course.semesterYear && course.semesterYear.length > 0 ? (
                      <ul style={{ paddingLeft: "20px" }}>
                        {course.semesterYear && course.semesterYear.length > 0
                          ? course.semesterYear
                              .map((sem) => sem.semesterName)
                              .join(", ")
                          : "N/A"}
                      </ul>
                    ) : (
                      <span>No semesters</span>
                    )}
                  </td>
                  <td>
                    <i
                      className="fa-solid fa-file-pen"
                      onClick={() => handleEdit(course._id)}
                      style={{ cursor: "pointer", marginRight: "10px" }}
                    ></i>
                    <i
                      className="fa-solid fa-trash-can"
                      onClick={() => handleDelete(course._id)}
                      style={{ cursor: "pointer" }}
                    ></i>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* headertable  */}
      </div>
      {/* college-all-course-inner-main-wrapper  */}
    </>
  );
};

export default UniversityAllCourses;
